export default __webpack_public_path__ + "static/media/sublerFacebook-1200x630.dbcb596d.png";